// extracted by mini-css-extract-plugin
export default {"container":"MessageBox_container__TB0NM"};